import { Formik } from 'formik';
import { Col, Row, Form } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import GenericButton from '../../common/button/GenericButton/GenericButton';
import { Link } from 'react-router-dom';
import * as yup from 'yup';

const FacilityForm = ({
  facilityUserData,
  facilityFormData,
  handleFacilityInput,
  validateProviderFacility,
  facilityValues,
}) => {
  const schema = yup.object({
    Speciality: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.Speciality?.Mandatory == true,
        then: () => yup.string().required(' Enter Speciality'),
        otherwise: () => yup.string().notRequired(),
      }),
    Previousclaimnumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.Previousclaimnumber?.Mandatory == true,
        then: () => yup.string().required(' Enter Previous claimnumber'),
        otherwise: () => yup.string().notRequired(),
      }),
    PhysiciansSocialSecurityNumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () =>
          facilityValues?.PhysiciansSocialSecurityNumber?.Mandatory == true,
        then: () =>
          yup.string().required("Enter Physician's Social Security Number"),
        otherwise: () => yup.string().notRequired(),
      }),
    PhysiciansLastName: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.PhysiciansLastName?.Mandatory == true,
        then: () => yup.string().required(" Enter Physician's Last Name"),
        otherwise: () => yup.string().notRequired(),
      }),
    PhysiciansFirstName: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.PhysiciansFirstName?.Mandatory == true,
        then: () => yup.string().required(" Enter Physician's First Name"),
        otherwise: () => yup.string().notRequired(),
      }),
    Email: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.Email?.Mandatory == true,
        then: () =>
          yup
            .string()
            .required(' Enter a valid email')
            .email('Enter Valid Email Address'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityAddressLine1: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityAddressLine1?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Facility Address Line 1'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityAddressLine3: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityAddressLine3?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Facility Address Line 3'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityCity: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityCity?.Mandatory == true,
        then: () => yup.string().required(' Enter a valid Facility Cityname'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityState: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityState?.Mandatory == true,
        then: () => yup.string().required(' Enter a valid Facility State name'),
        otherwise: () => yup.string().notRequired(),
      }),
    PhysiciansCertificateNumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () =>
          facilityValues?.PhysiciansCertificateNumber?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter Physician Certificate Number'),
        otherwise: () => yup.string().notRequired(),
      }),
    Phone: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.Phone?.Mandatory == true,
        then: () => yup.string().required(' Enter a valid phone number'),
        otherwise: () => yup.string().notRequired(),
      }),
    PhysicianAlternateID1: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.PhysicianAlternateID1?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Physician Alternate ID1'),
        otherwise: () => yup.string().notRequired(),
      }),
    PhysicianAlternateID2: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.PhysicianAlternateID2?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Physician Alternate ID2'),
        otherwise: () => yup.string().notRequired(),
      }),
    LicenseState: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.LicenseState?.Mandatory == true,
        then: () => yup.string().required(' Enter a valid License State'),
        otherwise: () => yup.string().notRequired(),
      }),
    LicenseNumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.LicenseNumber?.Mandatory == true,
        then: () => yup.string().required(` Enter a valid License Number`),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityTaxId: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityTaxId?.Mandatory == true,
        then: () => yup.string().required(` Enter a valid Facility TaxId`),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityPostalCode: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityPostalCode?.Mandatory == true,
        then: () => yup.string().required(' Enter a valid Facility PostalCode'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityName: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityName?.Mandatory == true,
        then: () => yup.string().required(' Enter a valid Facility Name'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityNPI: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityNPI?.Mandatory == true,
        then: () => yup.string().required(' Enter a valid Facility NPI'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityLicenseState: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityLicenseState?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Facility License State'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityLicenseNumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityLicenseNumber?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Facility License Number'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityCertificateNumber: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityCertificateNumber?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Facility Certificate Number'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityAlternateID2: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityAlternateID2?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Facility Alternate ID2'),
        otherwise: () => yup.string().notRequired(),
      }),
    FacilityAlternateID1: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.FacilityAlternateID1?.Mandatory == true,
        then: () =>
          yup.string().required(' Enter a valid Facility Alternate ID1'),
        otherwise: () => yup.string().notRequired(),
      }),
    BillingTaxID: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.BillingTaxID?.Mandatory == true,
        then: () => yup.string().required(' Enter a valid Billing TaxID'),
        otherwise: () => yup.string().notRequired(),
      }),
    PhysiciansDateofBirth: yup
      .string()
      .ensure()
      .when('required', {
        is: () => facilityValues?.PhysiciansDateofBirth?.Mandatory == true,
        then: () =>
          yup
            .string()
            .required(" Enter a valid Billing Physician's Date of Birth"),
        otherwise: () => yup.string().notRequired(),
      }),
  });
  return (
    <>
      <div className="provider-user-profile-info">
        <div className="mt-4">
          <Row className="ml-0">
            <Col md={12} className="p-0">
              <Formik
                validationSchema={schema}
                initialValues={{
                  Speciality: facilityFormData.Speciality,
                  Previousclaimnumber: facilityFormData.Previousclaimnumber,
                  PhysiciansSocialSecurityNumber:
                    facilityFormData.physicianssocialsecuritynumber,
                  PhysiciansLastName: facilityFormData.PhysiciansLastName,
                  PhysiciansFirstName: facilityFormData.PhysiciansFirstName,
                  PhysiciansDateofBirth: facilityFormData.PhysiciansDateofBirth,
                  PhysiciansCertificateNumber:
                    facilityFormData.PhysiciansCertificateNumber,
                  PhysicianNPI: facilityFormData.PhysicianNPI,
                  PhysicianAlternateID2: facilityFormData.PhysicianAlternateID2,
                  PhysicianAlternateID1: facilityFormData.PhysicianAlternateID1,
                  Phone: facilityFormData.Phone,
                  LicenseState: facilityFormData.LicenseState,
                  LicenseNumber: facilityFormData.LicenseNumber,
                  FacilityTaxId: facilityFormData.FacilityTaxId,
                  FacilityState: facilityFormData.FacilityState,
                  FacilityPostalCode: facilityFormData.FacilityPostalCode,
                  FacilityName: facilityFormData.FacilityName,
                  FacilityNPI: facilityFormData.FacilityNPI,
                  FacilityLicenseState: facilityFormData.FacilityLicenseState,
                  FacilityLicenseNumber: facilityFormData.FacilityLicenseNumber,
                  FacilityCity: facilityFormData.FacilityCity,
                  FacilityCertificateNumber:
                    facilityFormData.FacilityCertificateNumber,
                  FacilityAlternateID2: facilityFormData.FacilityAlternateID2,
                  FacilityAlternateID1: facilityFormData.FacilityAlternateID1,
                  FacilityAddressLine1: facilityFormData.FacilityAddressLine1,
                  Email: facilityFormData.Email,
                  BillingTaxID: facilityFormData.BillingTaxID,
                }}
                onSubmit={() => {
                  validateProviderFacility();
                }}
              >
                {({
                  values,
                  touched,
                  errors,
                  status,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  setStatus,
                  setFieldValue,
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      {facilityValues?.Speciality?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.Speciality.Fields}
                                {facilityValues.Speciality.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="Speciality"
                                placeholder=""
                                className={
                                  status && status.Speciality
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.Speciality}
                                isInvalid={
                                  touched.Speciality && errors.Speciality
                                }
                                onChange={(e) => {
                                  console.log('firstname', e.target.value, e);
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.Speciality ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.Speciality}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.Speciality && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.Speciality && errors.Speciality}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.Previousclaimnumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.Previousclaimnumber.Fields}
                                {facilityValues.Previousclaimnumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="Previousclaimnumber"
                                placeholder=""
                                className={
                                  status && status.Previousclaimnumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.Previousclaimnumber}
                                isInvalid={
                                  touched.Previousclaimnumber &&
                                  errors.Previousclaimnumber
                                }
                                onChange={(e) => {
                                  console.log('firstname', e.target.value, e);
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.Previousclaimnumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.Previousclaimnumber}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.Previousclaimnumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.Previousclaimnumber &&
                                        errors.Previousclaimnumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}

                      {facilityValues?.PhysiciansSocialSecurityNumber
                        ?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  facilityValues.PhysiciansSocialSecurityNumber
                                    .Description
                                }
                                {facilityValues.PhysiciansSocialSecurityNumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="PhysiciansSocialSecurityNumber"
                                placeholder=""
                                className={
                                  status &&
                                  status.PhysiciansSocialSecurityNumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={
                                  facilityFormData?.PhysiciansSocialSecurityNumber
                                }
                                isInvalid={
                                  touched.PhysiciansSocialSecurityNumber &&
                                  errors.PhysiciansSocialSecurityNumber
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status &&
                              status.PhysiciansSocialSecurityNumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {status.PhysiciansSocialSecurityNumber}
                                  </span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.PhysiciansSocialSecurityNumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.PhysiciansSocialSecurityNumber &&
                                        errors.PhysiciansSocialSecurityNumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}

                      {facilityValues?.PhysiciansFirstName?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.PhysiciansFirstName.Description}
                                {facilityValues.PhysiciansFirstName
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="PhysiciansFirstName"
                                placeholder=""
                                className={
                                  status && status.PhysiciansFirstName
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.PhysiciansFirstName}
                                isInvalid={
                                  touched.PhysiciansFirstName &&
                                  errors.PhysiciansFirstName
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.PhysiciansFirstName ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.PhysiciansFirstName}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.PhysiciansFirstName && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.PhysiciansFirstName &&
                                        errors.PhysiciansFirstName}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.PhysiciansLastName?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.PhysiciansLastName.Description}
                                {facilityValues.PhysiciansLastName
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="PhysiciansLastName"
                                placeholder=""
                                className={
                                  status && status.PhysiciansLastName
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.PhysiciansLastName}
                                isInvalid={
                                  touched.PhysiciansLastName &&
                                  errors.PhysiciansLastName
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.PhysiciansLastName ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.PhysiciansLastName}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.PhysiciansLastName && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.PhysiciansLastName &&
                                        errors.PhysiciansLastName}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.PhysiciansDateofBirth?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  facilityValues.PhysiciansDateofBirth
                                    .Description
                                }
                                {facilityValues.PhysiciansDateofBirth
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="PhysiciansDateofBirth"
                                placeholder=""
                                className={
                                  status && status.PhysiciansDateofBirth
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.PhysiciansDateofBirth}
                                isInvalid={
                                  touched.PhysiciansDateofBirth &&
                                  errors.PhysiciansDateofBirth
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.PhysiciansDateofBirth ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.PhysiciansDateofBirth}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.PhysiciansDateofBirth && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.PhysiciansDateofBirth &&
                                        errors.PhysiciansDateofBirth}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.PhysiciansCertificateNumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  facilityValues.PhysiciansCertificateNumber
                                    .Description
                                }
                                {facilityValues.PhysiciansCertificateNumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="PhysiciansCertificateNumber"
                                placeholder=""
                                className={
                                  status && status.PhysiciansCertificateNumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={
                                  facilityFormData?.PhysiciansCertificateNumber
                                }
                                isInvalid={
                                  touched.PhysiciansCertificateNumber &&
                                  errors.PhysiciansCertificateNumber
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.PhysiciansCertificateNumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {status.PhysiciansCertificateNumber}
                                  </span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.PhysiciansCertificateNumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.PhysiciansCertificateNumber &&
                                        errors.PhysiciansCertificateNumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.PhysicianNPI?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.PhysicianNPI.Description}
                                {facilityValues.PhysicianNPI.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="PhysicianNPI"
                                placeholder=""
                                className={
                                  status && status.PhysicianNPI
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.PhysicianNPI}
                                isInvalid={
                                  touched.PhysicianNPI && errors.PhysicianNPI
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.PhysicianNPI ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.PhysicianNPI}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.PhysicianNPI && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.PhysicianNPI &&
                                        errors.PhysicianNPI}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.PhysicianAlternateID2?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  facilityValues.PhysicianAlternateID2
                                    .Description
                                }
                                {facilityValues.PhysicianAlternateID2
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="PhysicianAlternateID2"
                                placeholder=""
                                className={
                                  status && status.PhysicianAlternateID2
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.PhysicianAlternateID2}
                                isInvalid={
                                  touched.PhysicianAlternateID2 &&
                                  errors.PhysicianAlternateID2
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.PhysicianAlternateID2 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.PhysicianAlternateID2}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.PhysicianAlternateID2 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.PhysicianAlternateID2 &&
                                        errors.PhysicianAlternateID2}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.PhysicianAlternateID1?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  facilityValues.PhysicianAlternateID1
                                    .Description
                                }
                                {facilityValues.PhysicianAlternateID1
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="PhysicianAlternateID1"
                                placeholder=""
                                className={
                                  status && status.PhysicianAlternateID1
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.PhysicianAlternateID1}
                                isInvalid={
                                  touched.PhysicianAlternateID1 &&
                                  errors.PhysicianAlternateID1
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.PhysicianAlternateID1 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.PhysicianAlternateID1}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.PhysicianAlternateID1 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.PhysicianAlternateID1 &&
                                        errors.PhysicianAlternateID1}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.Phone?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.Phone.Fields}
                                {facilityValues.Phone.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="Phone"
                                placeholder=""
                                className={
                                  status && status.Phone ? 'is-invalid' : ''
                                }
                                value={facilityFormData?.Phone}
                                isInvalid={touched.Phone && errors.Phone}
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.Phone ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.Phone}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.Phone && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>{touched.Phone && errors.Phone}</span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.LicenseState?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.LicenseState.Fields}
                                {facilityValues.LicenseState.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="LicenseState"
                                placeholder=""
                                className={
                                  status && status.LicenseState
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.LicenseState}
                                isInvalid={
                                  touched.LicenseState && errors.LicenseState
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.LicenseState ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.LicenseState}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.LicenseState && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.LicenseState &&
                                        errors.LicenseState}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.LicenseNumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.LicenseNumber.Fields}
                                {facilityValues.LicenseNumber.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="LicenseNumber"
                                placeholder=""
                                className={
                                  status && status.LicenseNumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.LicenseNumber}
                                isInvalid={
                                  touched.LicenseNumber && errors.LicenseNumber
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.LicenseNumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.LicenseNumber}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.LicenseNumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.LicenseNumber &&
                                        errors.LicenseNumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityTaxId?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityTaxId.Fields}
                                {facilityValues.FacilityTaxId.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityTaxId"
                                placeholder=""
                                className={
                                  status && status.FacilityTaxId
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityTaxId}
                                isInvalid={
                                  touched.FacilityTaxId && errors.FacilityTaxId
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityTaxId ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityTaxId}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityTaxId && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityTaxId &&
                                        errors.FacilityTaxId}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityState?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityState.Fields}
                                {facilityValues.FacilityState.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityState"
                                placeholder=""
                                className={
                                  status && status.FacilityState
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityState}
                                isInvalid={
                                  touched.FacilityState && errors.FacilityState
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityState ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityState}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityState && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityState &&
                                        errors.FacilityState}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityPostalCode?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityPostalCode.Fields}
                                {facilityValues.FacilityPostalCode
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityPostalCode"
                                placeholder=""
                                className={
                                  status && status.FacilityPostalCode
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityPostalCode}
                                isInvalid={
                                  touched.FacilityPostalCode &&
                                  errors.FacilityPostalCode
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityPostalCode ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityPostalCode}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityPostalCode && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityPostalCode &&
                                        errors.FacilityPostalCode}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityName?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityName.Fields}
                                {facilityValues.FacilityName.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityName"
                                placeholder=""
                                className={
                                  status && status.FacilityName
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityName}
                                isInvalid={
                                  touched.FacilityName && errors.FacilityName
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityName ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityName}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityName && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityName &&
                                        errors.FacilityName}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityNPI?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityNPI.Fields}
                                {facilityValues.FacilityNPI.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityNPI"
                                placeholder=""
                                className={
                                  status && status.FacilityNPI
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityNPI}
                                isInvalid={
                                  touched.FacilityNPI && errors.FacilityNPI
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityNPI ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityNPI}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityNPI && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityNPI &&
                                        errors.FacilityNPI}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityLicenseState?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityLicenseState.Fields}
                                {facilityValues.FacilityLicenseState
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityLicenseState"
                                placeholder=""
                                className={
                                  status && status.FacilityLicenseState
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityLicenseState}
                                isInvalid={
                                  touched.FacilityLicenseState &&
                                  errors.FacilityLicenseState
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityLicenseState ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityLicenseState}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityLicenseState && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityLicenseState &&
                                        errors.FacilityLicenseState}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityLicenseNumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityLicenseNumber.Fields}
                                {facilityValues.FacilityLicenseNumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityLicenseNumber"
                                placeholder=""
                                className={
                                  status && status.FacilityLicenseNumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityLicenseNumber}
                                isInvalid={
                                  touched.FacilityLicenseNumber &&
                                  errors.FacilityLicenseNumber
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityLicenseNumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityLicenseNumber}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityLicenseNumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityLicenseNumber &&
                                        errors.FacilityLicenseNumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityCity?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityCity.Fields}
                                {facilityValues.FacilityCity.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityCity"
                                placeholder=""
                                className={
                                  status && status.FacilityCity
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityCity}
                                isInvalid={
                                  touched.FacilityCity && errors.FacilityCity
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityCity ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityCity}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityCity && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityCity &&
                                        errors.FacilityCity}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityCertificateNumber?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {
                                  facilityValues.FacilityCertificateNumber
                                    .Fields
                                }
                                {facilityValues.FacilityCertificateNumber
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityCertificateNumber"
                                placeholder=""
                                className={
                                  status && status.FacilityCertificateNumber
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={
                                  facilityFormData?.FacilityCertificateNumber
                                }
                                isInvalid={
                                  touched.FacilityCertificateNumber &&
                                  errors.FacilityCertificateNumber
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityCertificateNumber ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {status.FacilityCertificateNumber}
                                  </span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityCertificateNumber && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityCertificateNumber &&
                                        errors.FacilityCertificateNumber}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityAlternateID2?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityAlternateID2.Fields}
                                {facilityValues.FacilityAlternateID2
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityAlternateID2"
                                placeholder=""
                                className={
                                  status && status.FacilityAlternateID2
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityAlternateID2}
                                isInvalid={
                                  touched.FacilityAlternateID2 &&
                                  errors.FacilityAlternateID2
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityAlternateID2 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityAlternateID2}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityAlternateID2 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityAlternateID2 &&
                                        errors.FacilityAlternateID2}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityAlternateID1?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityAlternateID1.Fields}
                                {facilityValues.FacilityAlternateID1
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityAlternateID1"
                                placeholder=""
                                className={
                                  status && status.FacilityAlternateID1
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={facilityFormData?.FacilityAlternateID1}
                                isInvalid={
                                  touched.FacilityAlternateID1 &&
                                  errors.FacilityAlternateID1
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                  values;
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityAlternateID1 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityAlternateID1}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityAlternateID1 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityAlternateID1 &&
                                        errors.FacilityAlternateID1}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.FacilityAddressLine1?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.FacilityAddressLine1.Fields}
                                {facilityValues.FacilityAddressLine1
                                  .Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="FacilityAddressLine1"
                                placeholder=""
                                className={
                                  status && status.FacilityAddressLine1
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values?.FacilityAddressLine1}
                                isInvalid={
                                  touched.FacilityAddressLine1 &&
                                  errors.FacilityAddressLine1
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.FacilityAddressLine1 ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.FacilityAddressLine1}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.FacilityAddressLine1 && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.FacilityAddressLine1 &&
                                        errors.FacilityAddressLine1}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.Email?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.Email.Fields}
                                {facilityValues.Email.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="Email"
                                placeholder=""
                                className={
                                  status && status.Email ? 'is-invalid' : ''
                                }
                                value={values?.Email}
                                isInvalid={touched.Email && errors.Email}
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.Email ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.Email}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.Email && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>{touched.Email && errors.Email}</span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {facilityValues?.BillingTaxID?.Display && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                {facilityValues.BillingTaxID.Fields}
                                {facilityValues.BillingTaxID.Mandatory && (
                                  <sup className="text-danger">*</sup>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="BillingTaxID"
                                placeholder=""
                                className={
                                  status && status.BillingTaxID
                                    ? 'is-invalid'
                                    : ''
                                }
                                value={values?.BillingTaxID}
                                isInvalid={
                                  touched.BillingTaxID && errors.BillingTaxID
                                }
                                onChange={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  handleFacilityInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                    'blur',
                                  );
                                }}
                              />
                              {status && status.BillingTaxID ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.BillingTaxID}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.BillingTaxID && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.BillingTaxID &&
                                        errors.BillingTaxID}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}

                      <Row className="mt-3 d-flex">
                        <Col sm={3} className="already-registered ">
                          Already registered?
                          <Link to="/admin">Login here. </Link>
                        </Col>
                        <Col sm={3} className="text-right">
                          {' '}
                          <GenericButton className="ml-1" type="submit">
                            NEXT
                          </GenericButton>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default FacilityForm;
